import { collection, writeBatch, increment, doc, serverTimestamp, Timestamp, query, where, getDocs, getCountFromServer } from "firebase/firestore";
import { db } from "../firebase/config.js";

export async function addOrder(eventId, orderProps, numTickets) {

    const batch = writeBatch(db);

    const orderRef = doc(collection(db, "orders"));
    const orderId = orderRef.id;
    const eventRef = doc(db, "events", eventId);

    const orderData = {
        ...orderProps,
        createdAt: serverTimestamp()
    };

    batch.set(orderRef, orderData);
    batch.update(eventRef, {
        numReserved: increment(numTickets),
    });

    try {
        await batch.commit();
        console.log("Order created and event updated successfully.");
        return orderId;
    } catch (error) {
        console.error("Batch operation failed:", error);
        throw error;
    }
}



export async function getOrdersCount() {
    const ordersRef = collection(db, "orders");

    try {
        const snapshot = await getCountFromServer(ordersRef);
        console.log(`Total orders: ${snapshot.data().count}`);
        return snapshot.data().count;
    } catch (error) {
        console.error("Failed to get order count:", error);
        return null;
    }
}

export async function deleteOldOrders() {


    return
    //Carefull here !

    const cutoffDate = new Date('2025-07-27T00:00:00Z'); // Adjust to your timezone if needed
    const cutoffTimestamp = Timestamp.fromDate(cutoffDate);

    const ordersRef = collection(db, 'orders');
    const q = query(ordersRef, where('createdAt', '<', cutoffTimestamp));

    const snapshot = await getDocs(q);
    if (snapshot.empty) {
        console.log('No orders to delete.');
        return;
    }

    console.log("ALL: " + JSON.stringify(snapshot))

    const batch = writeBatch(db);
    snapshot.docs.forEach((doc) => {
        batch.delete(doc.ref);
    });

    try {
        await batch.commit();
        console.log(`Deleted ${snapshot.size} old order(s).`);
    } catch (error) {
        console.error('Error deleting old orders:', error);
    }
}